import {
  postPhotoMemories,
  postStoriesMemories,
  postAudioMemories,
  postDocumentMemories,
  deleteMemory,
} from '../../../../wcf/global/services'

import useEP from '../../../hooks/useEP'

export const usePostPhotoMemories = () => {
  const [state, dispatch, func] = useEP(postPhotoMemories)

  return [state, func, dispatch]
}

export const usePostStoriesMemories = () => {
  const [state, dispatch, func] = useEP(postStoriesMemories)

  return [state, func, dispatch]
}

export const usePostDocumentMemories = () => {
  const [state, dispatch, func] = useEP(postDocumentMemories)

  return [state, func, dispatch]
}

export const usePostAudioMemories = () => {
  const [state, dispatch, func] = useEP(postAudioMemories)

  return [state, func, dispatch]
}

export const useDeleteMemory = () => {
  const [state, dispatch, func] = useEP(deleteMemory)

  return [state, func, dispatch]
}
